import { Injectable } from '@angular/core';
import { HttpClient } from './http-client.service';
import { Logger } from '../logger.service';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import * as moment from 'moment';

let fileSaver = require('../../FileSaver');

export interface Counts {
	"count": number,
	"redeemed": number,
	"unused": number
}

@Injectable()
export class AccessCodesApi {
	private accessCodesUrl = '/api/accesscodes/v1';

	constructor(private httpClient: HttpClient, private logger: Logger) {
	}

	public generateAccessCodes(eventUuid: string, priceLevelUuid: string, amount: number): Observable<any> {
		this.logger.info(`Generate access codes for Event[${eventUuid}], PL[${priceLevelUuid}]`);
		return this.httpClient.post(this.accessCodesUrl + "/" + eventUuid + "/" + priceLevelUuid + "/generate?number=" + amount)
			.map(response => response.json())
			.catch(this.handleError)
	}

	public downloadCodes(priceLevelUuid: string, filter: string): Observable<void> {
		this.logger.info(`Download access codes for PL[${priceLevelUuid}] filter[${filter}]`);
		return this.httpClient.get(this.accessCodesUrl + "/export/" + priceLevelUuid + (filter ? `/${filter}` : ""))
			.map(response => {
				fileSaver.saveAs(
					new Blob([response.text()]),
					`access-codes${filter ? "_" + filter : ""}` + "_" + priceLevelUuid + "_" + moment().format("YYYY-MM-DD_HH-mm-ss") + ".csv"
				);
			})
			.catch(this.handleError)
	}

	public loadCounts(priceLevelUuid: string): Observable<Counts> {
		this.logger.info(`Load access code counts for PL[${priceLevelUuid}]`);
		return this.httpClient.get(this.accessCodesUrl + "/" + priceLevelUuid + "/count")
			.map(response => response.json())
			.catch(this.handleError)
	}

	private handleError = (error: Response) => {
		this.logger.error(error);
		return Observable.throw(error);
	}
}



// WEBPACK FOOTER //
// ./src/app/services/webservice/access-codes-api.service.ts